import React from 'react';
import { T } from 'shared/helper/translate';
var Link = function Link(_ref) {
  var link = _ref.link,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    setShowMobileMenu = _ref.setShowMobileMenu;
  return /*#__PURE__*/React.createElement("div", {
    className: "link-container"
  }, /*#__PURE__*/React.createElement("a", {
    "aria-label": "link",
    href: link.url,
    key: link.title,
    target: "_self",
    className: "dropdown-item icon-bullet-link ".concat(className),
    rel: "noreferrer",
    onClick: function onClick() {
      return setShowMobileMenu ? setShowMobileMenu(false) : null;
    }
  }, /*#__PURE__*/React.createElement(T, {
    source: link.text
  })), link.isPopular && /*#__PURE__*/React.createElement("span", {
    className: "popular-tag"
  }, /*#__PURE__*/React.createElement(T, {
    source: "popular"
  })));
};
export default Link;